// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Core__Array from "@rescript/core/src/Core__Array.bs.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as PaymentMethodCollectUtils$OrcaPaymentPage from "./Utilities/PaymentMethodCollectUtils.bs.js";

function FormViewJourney(props) {
  var journeyView = props.journeyView;
  var enabledPaymentMethodsWithDynamicFields = props.enabledPaymentMethodsWithDynamicFields;
  var handleSubmit = props.handleSubmit;
  var primaryTheme = props.primaryTheme;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var payoutDynamicFields = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.payoutDynamicFieldsAtom);
  var formData = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.formDataAtom);
  var match$1 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.paymentMethodTypeAtom);
  var setActivePmt = match$1[1];
  var activePmt = match$1[0];
  var match$2 = Jotai.useAtom(JotaiAtoms$OrcaPaymentPage.validityDictAtom);
  var setValidityDict = match$2[1];
  var validityDict = match$2[0];
  var paymentMethodListValue = Jotai.useAtomValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var supportedCardBrands = React.useMemo((function () {
          return PaymentUtils$OrcaPaymentPage.getSupportedCardBrands(paymentMethodListValue);
        }), [paymentMethodListValue]);
  var match$3 = React.useState(function () {
        return false;
      });
  var setFormSubmitted = match$3[1];
  var formSubmitted = match$3[0];
  var viewStack = React.useRef([journeyView]);
  var push = function (newState) {
    viewStack.current = Belt_Array.concatMany([
          viewStack.current,
          [newState]
        ]);
  };
  var pop = function () {
    var match = viewStack.current.length;
    if (!(match === 0 || match === 1)) {
      viewStack.current.pop();
      return ;
    }
    
  };
  var get = function () {
    return Core__Option.getOr(viewStack.current[viewStack.current.length - 1 | 0], journeyView);
  };
  var match$4 = React.useState(function () {
        return get();
      });
  var setStateView = match$4[1];
  var view = match$4[0];
  var setView = function (view) {
    setStateView(function (param) {
          push(view);
          return view;
        });
  };
  var popView = function (countOpt) {
    var count = countOpt !== undefined ? countOpt : 1;
    setStateView(function (param) {
          for(var _for = 1; _for <= count; ++_for){
            pop();
          }
          return get();
        });
  };
  var renderInfoTemplate = function (label, value, uniqueKey) {
    return React.createElement("div", {
                key: uniqueKey,
                className: "flex flex-row items-center"
              }, React.createElement("div", {
                    className: "w-4/10 text-jp-gray-800 text-sm min-w-40 text-end"
                  }, label), React.createElement("div", {
                    className: "mx-2.5 h-4 w-0.5 bg-jp-gray-300"
                  }, ""), React.createElement("div", {
                    className: "w-6/10 text-sm min-w-40"
                  }, value));
  };
  var renderBackButton = function () {
    return React.createElement("div", {
                className: "flex justify-center items-center"
              }, React.createElement("button", {
                    className: "bg-jp-gray-600 rounded-full h-7 w-7 self-center mr-5",
                    onClick: (function (param) {
                        popView(undefined);
                      })
                  }, "←"));
  };
  var renderSaveButton = function (onClickHandler) {
    return React.createElement("button", {
                className: "min-w-full mt-10 text-lg font-semibold px-2.5 py-1.5 text-white rounded",
                style: {
                  backgroundColor: primaryTheme
                },
                onClick: onClickHandler
              }, localeString.formSaveText);
  };
  var renderHeader = function (title, shouldRenderBackButton) {
    return React.createElement("div", {
                className: "flex flex-row justify-start"
              }, shouldRenderBackButton ? renderBackButton() : null, React.createElement("div", {
                    className: "text-xl lg:text-3xl font-semibold"
                  }, title));
  };
  var contentSubHeaderClasses = "text-base text-gray-500";
  var tmp;
  if (typeof view !== "object") {
    tmp = React.createElement(React.Fragment, {}, renderHeader(localeString.formHeaderSelectAccountText, false), React.createElement("div", {
              className: contentSubHeaderClasses
            }, localeString.formFundsInfoText), React.createElement("div", {
              className: "mt-2.5"
            }, React.createElement("div", {
                  className: "flex flex-col mt-2.5"
                }, props.availablePaymentMethods.map(function (option, i) {
                      return React.createElement("button", {
                                  key: i.toString(),
                                  className: "flex flex-row items-center border border-solid border-jp-gray-200 px-5 py-2.5 rounded mt-2.5 hover:bg-jp-gray-50",
                                  onClick: (function (param) {
                                      var newView;
                                      if (option === "Card") {
                                        var newPmt = {
                                          TAG: "Card",
                                          _0: "Debit"
                                        };
                                        var payoutDynamicFields = Core__Option.getOr(PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutDynamicFields(enabledPaymentMethodsWithDynamicFields, newPmt), PaymentMethodCollectUtils$OrcaPaymentPage.defaultPayoutDynamicFields(newPmt));
                                        setActivePmt(function (param) {
                                              return newPmt;
                                            });
                                        newView = Core__Option.getOr(Core__Option.map(payoutDynamicFields.address, (function (address) {
                                                    var fieldsToCollect = address.filter(function (addressField) {
                                                          return addressField.value === undefined;
                                                        });
                                                    if (fieldsToCollect.length > 0) {
                                                      return {
                                                              TAG: "AddressForm",
                                                              _0: address
                                                            };
                                                    } else {
                                                      return {
                                                              TAG: "PMDForm",
                                                              _0: newPmt,
                                                              _1: payoutDynamicFields.payoutMethodData
                                                            };
                                                    }
                                                  })), {
                                              TAG: "PMDForm",
                                              _0: newPmt,
                                              _1: payoutDynamicFields.payoutMethodData
                                            });
                                      } else {
                                        newView = {
                                          TAG: "SelectPMType",
                                          _0: option
                                        };
                                      }
                                      setView(newView);
                                    })
                                }, PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodIcon(option), React.createElement("label", {
                                      className: "text-start ml-2.5 cursor-pointer"
                                    }, String(option)));
                    }))));
  } else {
    switch (view.TAG) {
      case "SelectPMType" :
          var selectedPm = view._0;
          var availablePmts = Core__Array.filterMap(props.availablePaymentMethodTypes, (function (pmt) {
                  switch (selectedPm) {
                    case "Card" :
                        return ;
                    case "BankRedirect" :
                        if (pmt.TAG === "BankRedirect") {
                          return {
                                  TAG: "BankRedirect",
                                  _0: pmt._0
                                };
                        } else {
                          return ;
                        }
                    case "BankTransfer" :
                        if (pmt.TAG === "BankTransfer") {
                          return {
                                  TAG: "BankTransfer",
                                  _0: pmt._0
                                };
                        } else {
                          return ;
                        }
                    case "Wallet" :
                        if (pmt.TAG === "Wallet") {
                          return {
                                  TAG: "Wallet",
                                  _0: pmt._0
                                };
                        } else {
                          return ;
                        }
                    
                  }
                }));
          var optionSelectionHandler = function (newPmt) {
            setActivePmt(function (param) {
                  return newPmt;
                });
            var payoutDynamicFields = Core__Option.getOr(PaymentMethodCollectUtils$OrcaPaymentPage.getPayoutDynamicFields(enabledPaymentMethodsWithDynamicFields, newPmt), PaymentMethodCollectUtils$OrcaPaymentPage.defaultPayoutDynamicFields(newPmt));
            var newView = Core__Option.getOr(Core__Option.map(payoutDynamicFields.address, (function (address) {
                        var fieldsToCollect = address.filter(function (addressField) {
                              return addressField.value === undefined;
                            });
                        if (fieldsToCollect.length > 0) {
                          return {
                                  TAG: "AddressForm",
                                  _0: address
                                };
                        } else {
                          return {
                                  TAG: "PMDForm",
                                  _0: newPmt,
                                  _1: payoutDynamicFields.payoutMethodData
                                };
                        }
                      })), {
                  TAG: "PMDForm",
                  _0: newPmt,
                  _1: payoutDynamicFields.payoutMethodData
                });
            setView(newView);
          };
          if (selectedPm === "Card") {
            setView("SelectPM");
            tmp = null;
          } else {
            tmp = React.createElement(React.Fragment, {}, renderHeader(localeString.formHeaderSelectBankText, true), React.createElement("div", {
                      className: "mt-2.5"
                    }, React.createElement("div", {
                          className: "flex flex-col mt-2.5"
                        }, availablePmts.map(function (option, i) {
                              switch (option.TAG) {
                                case "Card" :
                                    return null;
                                case "BankRedirect" :
                                    var bankRedirect = option._0;
                                    return React.createElement("button", {
                                                key: i.toString(),
                                                className: "flex flex-row items-center border border-solid border-jp-gray-200 px-5 py-2.5 rounded mt-2.5 hover:bg-jp-gray-50",
                                                onClick: (function (param) {
                                                    optionSelectionHandler(option);
                                                  })
                                              }, PaymentMethodCollectUtils$OrcaPaymentPage.getBankRedirectIcon(bankRedirect), React.createElement("label", {
                                                    className: "text-start ml-2.5 cursor-pointer"
                                                  }, String(bankRedirect)));
                                case "BankTransfer" :
                                    var transfer = option._0;
                                    return React.createElement("button", {
                                                key: i.toString(),
                                                className: "flex flex-row items-center border border-solid border-jp-gray-200 px-5 py-2.5 rounded mt-2.5 hover:bg-jp-gray-50",
                                                onClick: (function (param) {
                                                    optionSelectionHandler(option);
                                                  })
                                              }, PaymentMethodCollectUtils$OrcaPaymentPage.getBankTransferIcon(transfer), React.createElement("label", {
                                                    className: "text-start ml-2.5 cursor-pointer"
                                                  }, String(transfer)));
                                case "Wallet" :
                                    var wallet = option._0;
                                    return React.createElement("button", {
                                                key: i.toString(),
                                                className: "flex flex-row items-center border border-solid border-jp-gray-200 px-5 py-2.5 rounded mt-2.5 hover:bg-jp-gray-50",
                                                onClick: (function (param) {
                                                    optionSelectionHandler(option);
                                                  })
                                              }, PaymentMethodCollectUtils$OrcaPaymentPage.getWalletIcon(wallet), React.createElement("label", {
                                                    className: "text-start ml-2.5 cursor-pointer"
                                                  }, String(wallet)));
                                
                              }
                            }))));
          }
          break;
      case "AddressForm" :
          var addressFields = view._0;
          var onSaveHandler = function () {
            var match = Core__Array.reduce(addressFields, [
                  {},
                  true
                ], (function (param, field) {
                    var fieldValidity = param[0];
                    var key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
                          TAG: "BillingAddress",
                          _0: field.fieldType
                        });
                    var value = Core__Option.getOr(formData[key], "");
                    var validity = PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity({
                          TAG: "BillingAddress",
                          _0: field.fieldType
                        }, value, "", false);
                    fieldValidity[key] = validity;
                    return [
                            fieldValidity,
                            param[1] && Caml_obj.notequal(validity, false)
                          ];
                  }));
            var fieldValidity = match[0];
            setValidityDict(function (param) {
                  return fieldValidity;
                });
            if (match[1]) {
              return setView({
                          TAG: "PMDForm",
                          _0: activePmt,
                          _1: payoutDynamicFields.payoutMethodData
                        });
            }
            
          };
          tmp = React.createElement(React.Fragment, {}, renderHeader(localeString.billingDetailsText, true), React.createElement("div", {
                    className: contentSubHeaderClasses
                  }, localeString.formSubheaderBillingDetailsText), React.createElement("div", {
                    className: "mt-2.5"
                  }, props.renderAddressForm(addressFields), renderSaveButton(function (param) {
                        onSaveHandler();
                      })));
          break;
      case "PMDForm" :
          var pmdFields = view._1;
          var activePmt$1 = view._0;
          var pm = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodForPmt(activePmt$1);
          var key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(activePmt$1);
          var onSaveHandler$1 = function () {
            var match = Core__Array.reduce(pmdFields, [
                  Object.assign({}, validityDict),
                  true
                ], (function (param, field) {
                    var fieldValidity = param[0];
                    var key = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
                          TAG: "PayoutMethodData",
                          _0: field.fieldType
                        });
                    var value = Core__Option.getOr(formData[key], "");
                    var validCardBrand = CardUtils$OrcaPaymentPage.getFirstValidCardSchemeFromPML(value, Core__Option.getOr(supportedCardBrands, []));
                    var newCardBrand = validCardBrand !== undefined ? validCardBrand : CardUtils$OrcaPaymentPage.getCardBrand(value);
                    var validity = PaymentMethodCollectUtils$OrcaPaymentPage.calculateValidity({
                          TAG: "PayoutMethodData",
                          _0: field.fieldType
                        }, value, newCardBrand, false);
                    fieldValidity[key] = validity;
                    return [
                            fieldValidity,
                            param[1] && Caml_obj.notequal(validity, false)
                          ];
                  }));
            var fieldValidity = match[0];
            setValidityDict(function (param) {
                  return fieldValidity;
                });
            if (match[1]) {
              Core__Option.map(PaymentMethodCollectUtils$OrcaPaymentPage.formPaymentMethodData(formData, fieldValidity, payoutDynamicFields), (function (pmd) {
                      setView({
                            TAG: "FinalizeView",
                            _0: [
                              activePmt$1,
                              pmd
                            ]
                          });
                    }));
              return ;
            }
            
          };
          var tmp$1;
          switch (pm) {
            case "Card" :
                tmp$1 = localeString.formHeaderEnterCardText;
                break;
            case "BankRedirect" :
            case "BankTransfer" :
                tmp$1 = localeString.formHeaderBankText(key);
                break;
            case "Wallet" :
                tmp$1 = localeString.formHeaderWalletText(key);
                break;
            
          }
          tmp = React.createElement(React.Fragment, {}, renderHeader(tmp$1, true), React.createElement("div", {
                    className: "mt-2.5"
                  }, props.renderPayoutMethodForm(pmdFields), renderSaveButton(function (param) {
                        onSaveHandler$1();
                      })));
          break;
      case "FinalizeView" :
          var match$5 = view._0;
          var formFields = match$5[1];
          var pmt = match$5[0];
          var pm$1 = PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodForPmt(pmt);
          tmp = React.createElement("div", undefined, React.createElement("div", {
                    className: "flex flex-col"
                  }, React.createElement("div", {
                        className: "flex flex-row items-center mb-2.5 text-xl font-semibold"
                      }, React.createElement("img", {
                            className: "h-6 w-auto",
                            alt: "",
                            src: "merchantLogo"
                          }), React.createElement("div", {
                            className: "ml-1.5"
                          }, localeString.formHeaderReviewTabLayoutText(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodTypeLabel(pmt)))), formFields.map(function (field, i) {
                        var value = field[1];
                        var field$1 = field[0];
                        if (field$1.TAG === "BillingAddress") {
                          return null;
                        }
                        var fieldType = field$1._0.fieldType;
                        if (typeof fieldType !== "object") {
                          return renderInfoTemplate(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldLabel({
                                          TAG: "PayoutMethodData",
                                          _0: fieldType
                                        }, localeString), value, i.toString());
                        }
                        if (fieldType._0 !== "CardExpMonth") {
                          return null;
                        }
                        var expiryYear = Core__Option.getOr(Core__Option.flatMap(formData[PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldKey({
                                          TAG: "PayoutMethodData",
                                          _0: {
                                            TAG: "CardExpDate",
                                            _0: "CardExpYear"
                                          }
                                        })], (function (value) {
                                    return Core__Option.map(value.split("/")[1], (function (year) {
                                                  return "20" + year.trim();
                                                }));
                                  })), "");
                        var expiryValue = value + " / " + expiryYear;
                        return renderInfoTemplate(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodDataFieldLabel({
                                        TAG: "PayoutMethodData",
                                        _0: {
                                          TAG: "CardExpDate",
                                          _0: "CardExpMonth"
                                        }
                                      }, localeString), expiryValue, i.toString());
                      })), React.createElement("div", {
                    className: "flex flex-row items-center min-w-full my-5 px-2.5 py-1.5 text-xs border border-solid border-blue-200 rounded bg-blue-50"
                  }, React.createElement("img", {
                        className: "h-3 w-auto mr-1.5",
                        alt: "",
                        src: "merchantLogo"
                      }), localeString.formFundsCreditInfoText(PaymentMethodCollectUtils$OrcaPaymentPage.getPaymentMethodLabel(pm$1).toLowerCase())), React.createElement("div", {
                    className: "flex my-5 text-lg font-semibold w-full"
                  }, React.createElement("button", {
                        className: "w-full px-2.5 py-1.5 rounded border border-solid",
                        style: {
                          borderColor: primaryTheme,
                          color: primaryTheme
                        },
                        disabled: formSubmitted,
                        onClick: (function (param) {
                            popView(viewStack.current.length - 2 | 0);
                          })
                      }, localeString.formEditText), React.createElement("button", {
                        className: "w-full px-2.5 py-1.5 text-white rounded ml-2.5",
                        style: {
                          backgroundColor: primaryTheme
                        },
                        disabled: formSubmitted,
                        onClick: (function (param) {
                            setFormSubmitted(function (param) {
                                  return true;
                                });
                            handleSubmit([
                                  pmt,
                                  formFields
                                ]);
                          })
                      }, formSubmitted ? localeString.formSubmittingText : localeString.formSubmitText)));
          break;
      
    }
  }
  return React.createElement("div", {
              className: "w-full max-w-[520px]"
            }, tmp);
}

var make = FormViewJourney;

var $$default = FormViewJourney;

export {
  make ,
  $$default as default,
}
/* jotai Not a pure module */
